import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "bg-white text-center text-black border-t mt-16"
}
const _hoisted_2 = { class: "container mx-auto p-6" }
const _hoisted_3 = { className: "text-left justify-left mb-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.$auth.isAuthenticated.value)
    ? (_openBlock(), _createElementBlock("footer", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[0] || (_cache[0] = _createElementVNode("ul", { class: "flex mb-6" }, [
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                class: "",
                href: "#",
                onclick: "Osano.cm.showDrawer('osano-cm-dom-info-dialog-open')"
              }, "Manage Cookies")
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                class: "px-2",
                href: "https://www.oliverwyman.com/content/dam/oliver-wyman/v2/legal/OW-General-Web-Portal-ToU.pdf",
                target: "_blank"
              }, " Terms Of Use ")
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                class: "px-2",
                href: "https://www.oliverwyman.com/policies/privacy-notice-platforms.html",
                target: "_blank"
              }, " Privacy Notice ")
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                class: "px-2",
                href: "https://www.oliverwyman.com/terms-of-use/statement-on-accessibility.html",
                target: "_blank"
              }, " Statement On Accessibility ")
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                class: "px-2",
                href: "https://www.oliverwyman.com/policies/cookie-notice.html",
                target: "_blank"
              }, " Cookie Notice ")
            ])
          ], -1)),
          _createElementVNode("p", _hoisted_3, " © " + _toDisplayString($setup.formatCurrentYear()) + " Oliver Wyman Inc. All Rights Reserved. ", 1)
        ])
      ]))
    : _createCommentVNode("", true)
}